import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';
import rootReducer from './data/reducer';

// const loggerMiddleware = createLogger();

/**
 *
 * @param {PhotoBoothApi} apiClient
 * @param feathersClient
 * @param predefinedState
 * @returns {Store<any>}
 */
export default function configureStore(apiClient, feathersClient, predefinedState) {
  const store = createStore(
    rootReducer,
    predefinedState,
    composeWithDevTools(
      applyMiddleware(thunkMiddleware.withExtraArgument({ apiClient, feathersClient }))
    )
  );

  apiClient.store = store;

  return store;
}



// WEBPACK FOOTER //
// ./src/store.js